import jsPDF from 'jspdf';

// Utility function to generate PDF for Events
export const generateEventsPDF = (events, eventType = 'All Events') => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 20;
  let yPosition = margin;

  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('TMGF - Events Report', pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 15;
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text(`Category: ${eventType}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 10;
  doc.setFontSize(10);
  doc.text(`Generated on: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 20;

  events.forEach((event, index) => {
    if (yPosition > pageHeight - 60) { doc.addPage(); yPosition = margin; }
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`${index + 1}. ${event.title}`, margin, yPosition);
    yPosition += 8;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Category: ${event.category}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Status: ${event.status}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Start Date: ${new Date(event.startDate).toLocaleDateString('en-US')}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`End Date: ${new Date(event.endDate).toLocaleDateString('en-US')}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Time: ${event.startTime} - ${event.endTime}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Location: ${event.location}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Volunteers Needed: ${event.volunteersNeeded}`, margin + 5, yPosition); yPosition += 6;
    const descriptionLines = doc.splitTextToSize(`Description: ${event.description}`, pageWidth - 2 * margin - 10);
    doc.text(descriptionLines, margin + 5, yPosition);
    yPosition += descriptionLines.length * 6;
    yPosition += 10;
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - margin, pageHeight - 10, { align: 'right' });
    doc.text('TMGF Volunteer Management System', margin, pageHeight - 10);
  }
  doc.save(`TMGF_Events_${eventType.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

// Utility function to generate PDF for Volunteers
export const generateVolunteersPDF = (volunteers, status = 'All Volunteers') => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 20;
  let yPosition = margin;

  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('TMGF - Volunteers Report', pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 15;
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text(`Status: ${status}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 10;
  doc.setFontSize(10);
  doc.text(`Total Volunteers: ${volunteers.length}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 5;
  doc.text(`Generated on: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 20;

  volunteers.forEach((volunteer, index) => {
    if (yPosition > pageHeight - 50) { doc.addPage(); yPosition = margin; }
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`${index + 1}. ${volunteer.name}`, margin, yPosition);
    yPosition += 8;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    doc.text(`Virtual ID: ${volunteer.virtualId}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Email: ${volunteer.email}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Phone: ${volunteer.mobileNo}`, margin + 5, yPosition); yPosition += 6;
    const addressLines = doc.splitTextToSize(`Address: ${volunteer.address}`, pageWidth - 2 * margin - 10);
    doc.text(addressLines, margin + 5, yPosition);
    yPosition += addressLines.length * 6;
    doc.text(`Status: ${volunteer.isActive ? 'Active' : 'Inactive'}`, margin + 5, yPosition); yPosition += 6;
    if (volunteer.createdAt) {
      doc.text(`Joined: ${new Date(volunteer.createdAt).toLocaleDateString('en-US')}`, margin + 5, yPosition);
      yPosition += 6;
    }
    yPosition += 8;
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - margin, pageHeight - 10, { align: 'right' });
    doc.text('TMGF Volunteer Management System', margin, pageHeight - 10);
  }
  doc.save(`TMGF_Volunteers_${status.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

// Utility function to generate summary statistics PDF
export const generateSummaryPDF = (data, title) => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 20;
  let yPosition = margin;

  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text(`TMGF - ${title}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 15;
  doc.setFontSize(10);
  doc.text(`Generated on: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 20;

  Object.entries(data).forEach(([key, value]) => {
    if (yPosition > pageHeight - 40) { doc.addPage(); yPosition = margin; }
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`${key}:`, margin, yPosition);
    doc.setFont('helvetica', 'normal');
    doc.text(`${value}`, margin + 60, yPosition);
    yPosition += 12;
  });

  doc.setFontSize(8);
  doc.text('TMGF Volunteer Management System', margin, pageHeight - 10);
  doc.text(`Page 1 of 1`, pageWidth - margin, pageHeight - 10, { align: 'right' });
  doc.save(`TMGF_${title.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

// Utility function to generate PDF for Help Requests
export const generateHelpRequestsPDF = (helpRequests, statusFilter = 'All Help Requests') => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 20;
  let yPosition = margin;

  doc.setFontSize(20);
  doc.setFont('helvetica', 'bold');
  doc.text('TMGF - Help Requests Report', pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 15;
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text(`Filter: ${statusFilter}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 10;
  doc.setFontSize(10);
  doc.text(`Total Requests: ${helpRequests.length}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 5;
  doc.text(`Generated on: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 20;

  helpRequests.forEach((request, index) => {
    if (yPosition > pageHeight - 80) { doc.addPage(); yPosition = margin; }
    doc.setFontSize(12);
    doc.setFont('helvetica', 'bold');
    doc.text(`${index + 1}. ${request.title}`, margin, yPosition);
    yPosition += 8;
    doc.setFontSize(10);
    doc.setFont('helvetica', 'normal');
    if (request.userId) {
      doc.text(`Volunteer Name: ${request.userId.name || 'N/A'}`, margin + 5, yPosition); yPosition += 6;
      doc.text(`Email: ${request.userId.email || 'N/A'}`, margin + 5, yPosition); yPosition += 6;
      doc.text(`Phone: ${request.userId.mobileNo || 'N/A'}`, margin + 5, yPosition); yPosition += 6;
    }
    doc.text(`Start Date: ${new Date(request.startDate).toLocaleDateString('en-US')}`, margin + 5, yPosition); yPosition += 6;
    if (request.endDate) { doc.text(`End Date: ${new Date(request.endDate).toLocaleDateString('en-US')}`, margin + 5, yPosition); yPosition += 6; }
    doc.text(`Time: ${request.startTime} - ${request.endTime}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Location: ${request.location}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Volunteers Needed: ${request.volunteersNeeded}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Category: ${request.category || 'N/A'}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Event Status: ${request.status}`, margin + 5, yPosition); yPosition += 6;
    doc.text(`Help Status: ${request.helpStatus.charAt(0).toUpperCase() + request.helpStatus.slice(1)}`, margin + 5, yPosition); yPosition += 6;
    if (request.helpFeedback && request.helpStatus !== 'pending') {
      const feedbackLines = doc.splitTextToSize(`Feedback: ${request.helpFeedback}`, pageWidth - 2 * margin - 10);
      doc.text(feedbackLines, margin + 5, yPosition);
      yPosition += feedbackLines.length * 6;
    } else if (request.helpStatus === 'pending') {
      doc.text('Feedback: Pending review', margin + 5, yPosition); yPosition += 6;
    }
    if (request.description) {
      const descriptionLines = doc.splitTextToSize(`Description: ${request.description}`, pageWidth - 2 * margin - 10);
      doc.text(descriptionLines, margin + 5, yPosition);
      yPosition += descriptionLines.length * 6;
    }
    yPosition += 12;
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - margin, pageHeight - 10, { align: 'right' });
    doc.text('TMGF Volunteer Management System', margin, pageHeight - 10);
  }
  doc.save(`TMGF_Help_Requests_${statusFilter.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.pdf`);
};

// Utility function to generate PDF for Event Volunteers
export const generateEventVolunteersPDF = (volunteers, eventTitle = 'Event') => {
  const doc = new jsPDF();
  const pageWidth = doc.internal.pageSize.width;
  const pageHeight = doc.internal.pageSize.height;
  const margin = 20;
  let yPosition = margin;

  doc.setFontSize(18);
  doc.setFont('helvetica', 'bold');
  doc.text('TMGF - Event Volunteers List', pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 12;
  doc.setFontSize(14);
  doc.setFont('helvetica', 'normal');
  doc.text(`Event: ${eventTitle}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 10;
  doc.setFontSize(10);
  doc.text(`Total Volunteers: ${volunteers.length}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 5;
  doc.text(`Generated on: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}`, pageWidth / 2, yPosition, { align: 'center' });
  yPosition += 20;

  doc.setFontSize(10);
  doc.setFont('helvetica', 'bold');
  doc.text('Sr.', margin, yPosition);
  doc.text('TMGF ID', margin + 20, yPosition);
  doc.text('Name', margin + 50, yPosition);
  doc.text('Email', margin + 100, yPosition);
  doc.text('Mobile', margin + 150, yPosition);
  yPosition += 8;
  doc.line(margin, yPosition - 2, pageWidth - margin, yPosition - 2);
  yPosition += 5;

  volunteers.forEach((volunteer, index) => {
    if (yPosition > pageHeight - 30) {
      doc.addPage();
      yPosition = margin;
      doc.setFont('helvetica', 'bold');
      doc.text('Sr.', margin, yPosition);
      doc.text('TMGF ID', margin + 20, yPosition);
      doc.text('Name', margin + 50, yPosition);
      doc.text('Email', margin + 100, yPosition);
      doc.text('Mobile', margin + 150, yPosition);
      yPosition += 8;
      doc.line(margin, yPosition - 2, pageWidth - margin, yPosition - 2);
      yPosition += 5;
    }
    doc.setFont('helvetica', 'normal');
    doc.text(`${index + 1}`, margin, yPosition);
    doc.text(volunteer.tmgfId || 'N/A', margin + 20, yPosition);
    const name = volunteer.name.length > 25 ? volunteer.name.substring(0, 22) + '...' : volunteer.name;
    const email = volunteer.email.length > 25 ? volunteer.email.substring(0, 22) + '...' : volunteer.email;
    doc.text(name, margin + 50, yPosition);
    doc.text(email, margin + 100, yPosition);
    doc.text(volunteer.mobileNo || 'N/A', margin + 150, yPosition);
    yPosition += 7;
  });

  const totalPages = doc.internal.getNumberOfPages();
  for (let i = 1; i <= totalPages; i++) {
    doc.setPage(i);
    doc.setFontSize(8);
    doc.setFont('helvetica', 'normal');
    doc.text(`Page ${i} of ${totalPages}`, pageWidth - margin, pageHeight - 10, { align: 'right' });
    doc.text('TMGF Volunteer Management System', margin, pageHeight - 10);
  }
  const eventName = eventTitle.replace(/[^a-zA-Z0-9]/g, '_');
  doc.save(`TMGF_Event_Volunteers_${eventName}_${new Date().toISOString().split('T')[0]}.pdf`);
};

// Utility function to print just the volunteers list (for browser print)
export const printVolunteersList = (volunteers, eventTitle = 'Event') => {
  const printWindow = window.open('', '_blank');
  const printContent = `
    <!DOCTYPE html>
    <html>
    <head>
      <title>Event Volunteers - ${eventTitle}</title>
      <style>
        body { font-family: Arial, sans-serif; margin: 20px; color: #333; }
        .header { text-align: center; margin-bottom: 30px; border-bottom: 2px solid #007bff; padding-bottom: 15px; }
        .header h1 { color: #007bff; margin: 0; font-size: 24px; }
        .header h2 { color: #666; margin: 5px 0; font-size: 18px; font-weight: normal; }
        .meta-info { text-align: center; margin-bottom: 20px; font-size: 12px; color: #666; }
        table { width: 100%; border-collapse: collapse; margin-top: 20px; }
        th, td { border: 1px solid #ddd; padding: 8px; text-align: left; }
        th { background-color: #007bff; color: white; font-weight: bold; }
        tr:nth-child(even) { background-color: #f9f9f9; }
        .footer { margin-top: 30px; padding-top: 15px; border-top: 1px solid #ddd; text-align: center; font-size: 10px; color: #666; }
        @media print { body { margin: 0; } .header { border-bottom: 2px solid #000; } th { background-color: #000 !important; color: white !important; } }
      </style>
    </head>
    <body>
      <div class="header">
        <h1>TMGF - Event Volunteers List</h1>
        <h2>${eventTitle}</h2>
      </div>
      <div class="meta-info">
        <p>Total Volunteers: ${volunteers.length} | Generated on: ${new Date().toLocaleDateString('en-US', { weekday: 'long', year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </div>
      <table>
        <thead>
          <tr>
            <th>Sr. No.</th><th>TMGF ID</th><th>Name</th><th>Email</th><th>Mobile</th><th>Type</th><th>Attendance</th>
          </tr>
        </thead>
        <tbody>
          ${volunteers.map((volunteer, index) => `
            <tr>
              <td>${index + 1}</td>
              <td>${volunteer.tmgfId || 'N/A'}</td>
              <td>${volunteer.name}</td>
              <td>${volunteer.email}</td>
              <td>${volunteer.mobileNo || 'N/A'}</td>
              <td>${volunteer.type || 'N/A'}</td>
              <td>${volunteer.EventUserMap?.attendance || 'Not Marked'}</td>
            </tr>
          `).join('')}
        </tbody>
      </table>
      <div class="footer">
        <p>TMGF Volunteer Management System - Event Volunteers Report</p>
      </div>
    </body>
    </html>
  `;
  printWindow.document.write(printContent);
  printWindow.document.close();
  printWindow.onload = function() {
    printWindow.print();
    printWindow.close();
  };
};

// Utility function to generate CSV for Volunteers
export const generateVolunteersCSV = (volunteers, status = 'All Volunteers') => {
  const headers = ['Name', 'Email', 'Phone', 'Address', 'Interests', 'Status', 'Joined'];
  const rows = volunteers.map(v => [
    v.name || '',
    v.email || '',
    v.mobileNo || '',
    v.address || '',
    v.interests || '',
    v.isAvailable ? 'Active' : 'Inactive',
    v.createdAt ? new Date(v.createdAt).toLocaleDateString('en-US') : '',
  ]);

  const csvContent = [headers, ...rows]
    .map(row => row.map(cell => `"${String(cell).replace(/"/g, '""')}"`).join(','))
    .join('\n');

  const blob = new Blob([csvContent], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const link = document.createElement('a');
  link.href = url;
  link.download = `TMGF_Volunteers_${status.replace(/\s+/g, '_')}_${new Date().toISOString().split('T')[0]}.csv`;
  link.click();
  URL.revokeObjectURL(url);
};